var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaobra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1226",
    "data-name": "Grupo 1226",
    transform: "translate(43 7703)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_88",
    className: "circleIconState",
    "data-name": "Elipse 88",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(-43 -7703)",
    fill: "#c7b301"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1222",
    "data-name": "Grupo 1222",
    transform: "translate(-340.863 -7930.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1205",
    "data-name": "Grupo 1205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_142",
    "data-name": "Ret\\xE2ngulo 142",
    width: 14.143,
    height: 7.242,
    rx: 1.505,
    transform: "translate(303.327 245.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_143",
    "data-name": "Ret\\xE2ngulo 143",
    width: 14.143,
    height: 7.242,
    rx: 1.505,
    transform: "translate(319.256 245.002)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_144",
    "data-name": "Ret\\xE2ngulo 144",
    width: 14.143,
    height: 7.242,
    rx: 1.505,
    transform: "translate(311.292 235.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_145",
    "data-name": "Ret\\xE2ngulo 145",
    width: 14.143,
    height: 7.242,
    rx: 1.505,
    transform: "translate(311.292 254.056)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaobra);
export default __webpack_public_path__ + "static/media/Na obra.72136eb3513a6a5c8062049317d697c1.svg";
export { ForwardRef as ReactComponent };